<template>
  <v-dialog v-model="dialog" max-width="720">
    <v-card :loading="loading">
      <v-card-title v-if="title && !loading">{{ title }}</v-card-title>
      <v-card-text v-if="description && !loading">{{ description }}</v-card-text>
      <v-skeleton-loader v-if="loading" type="article" class="mx-6"></v-skeleton-loader>
      <v-card-actions>
        <v-spacer></v-spacer>
        <slot name="bottom-btn">
          <WsBtn
            v-if="!hideCancelBtn"
            color="textSecondary"
            outlined
            :loading="loading"
            @click="$_onCancel()"
            >取消</WsBtn
          >
          <WsBtn @click="$_onSubmit()" :loading="loading" :color="color">{{ btnText }}</WsBtn>
        </slot>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data: () => ({
    dialog: false,
    item: null,
    loading: false,
  }),
  methods: {
    $_onCancel() {
      if (this.loading) return;
      this.close();
    },
    startLoading() {
      this.loading = true;
    },
    stopLoading() {
      this.loading = false;
    },
    $_onSubmit() {
      if (this.loading) return;
      this.$emit('submit', this.item);
    },
    open(item) {
      this.loading = false;
      this.item = item;
      this.dialog = true;
    },
    close() {
      this.dialog = false;
      this.loading = false;
    },
  },
  props: {
    title: {
      type: String,
      default: null,
    },
    description: {
      type: String,
      default: null,
    },
    btnText: {
      type: String,
      default: '確認刪除',
    },
    color: {
      type: String,
      default: 'deleteBtn white--text',
    },
    hideCancelBtn: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style>
</style>
